import React, {useState} from 'react';
import {Row, Col, Form, Button, Table, Spinner} from 'react-bootstrap'
import { OdooDataFile } from '../models/OdooResponse';
import { Licitacion } from '../models/Licitacion';
import {    FontAwesomeIcon    } from '@fortawesome/react-fontawesome'
import {faBook, faDownload} from '@fortawesome/free-solid-svg-icons'
import ComponentLicitacionModalOferentes from './ComponentLicitacionModalOferentes'
import ComponentInscripcionLicatacion from './ComponentInscripcionLicatacion'
import Config from '../config/default.json'
import '../components/ComponentLicitacionForm.scss'
interface PropsLicitacion{
    licitacion:Licitacion
}

const ComponentLicitacionForm: React.FC<PropsLicitacion> = (props) =>{
    const [showModalInscription, setshowModalInscription]       = useState(false)
    const [decreteAdjudicacionFile, setDecreteAdjudicacionFile] = useState('')
    const [swSpinnerPliego, setswSpinnerPliego]                 = useState(false);
    const [swSpinnerAdjudicacion, setswSpinnerAdjudicacion]     = useState(false);
    const [swSpinnerApertura, setSwSpinnerApertura]             = useState(false);
    const trs_table =[]
    const adj_table =[]
    const plus_book                    = <FontAwesomeIcon className="icon-book" icon={faBook} />
    const download_icon                = <FontAwesomeIcon className="icon-button" icon={faDownload} />

    const handleClose = () =>{
        setshowModalInscription(false)
    }

    //SETEA INSCRIPTOS A LA LICITACION
    if (props.licitacion.inscripcion_ids){
        for (let j = 0; j < (props.licitacion.inscripcion_ids).length; j++ )
        {
            let licitacion = props.licitacion.inscripcion_ids[j];
            trs_table.push(<ComponentInscripcionLicatacion oferente={licitacion}></ComponentInscripcionLicatacion>)
        }
    }

    //SETEA ADJUDICADOS A LA LICITACION
    if (props.licitacion.adjudicado_ids){
        for (let j = 0; j < (props.licitacion.adjudicado_ids).length; j++ )
        {
            let licitacion = props.licitacion.adjudicado_ids[j];
            adj_table.push(<ComponentInscripcionLicatacion oferente={licitacion}></ComponentInscripcionLicatacion>)
        }
    }
    
    //DEVUELVE UNA ESTRUCTURA CON INFORMACION DE UN ARCHIVO Y DESCARGA ESE ARCHIVO
    const getFileLicitacion=(id: string, file_name:string)=>{
        file_name === 'pliego_y_decreto'?setswSpinnerPliego(true):file_name === 'decreto_adjudicacion'?setswSpinnerAdjudicacion(true):setSwSpinnerApertura(true)
        let requestOptions = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
            body: JSON.stringify({'atta_id':id,
                                  'file_name':file_name,
                                  'licitacion_id': props.licitacion.id }),    
        };
        fetch(Config.Production.Host.url+'/return_file',requestOptions).then((response) => {
            return response.json();
        }).then((respuesta: OdooDataFile) => {
          if (respuesta.result){

            // result domain {name:"","fiel64":"","extencion":"","mime":""}
            //Transformo el base 64 en un blob
            let blob = b64toBlob("data:"+ respuesta.result.mime+ ";base64," + respuesta.result.file64)
            setTimeout(() => {
              setswSpinnerPliego(false)
              setswSpinnerAdjudicacion(false)
              setSwSpinnerApertura(false)
              let csvURL    = window.URL.createObjectURL(blob);
              let tempLink  = document.createElement('a');
              tempLink.href = csvURL;
              tempLink.setAttribute('download', respuesta.result.name+ respuesta.result.extencion);
              tempLink.click();
            }, 550);
          }else{
              setswSpinnerPliego(false)
              setswSpinnerAdjudicacion(false)
              setSwSpinnerApertura(false)
          }
        });   
      }

      //Transformo el base 64 en un blob
      const b64toBlob=(dataURI: string)=> {
        var byteString = atob(dataURI.split(',')[1]);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: 'image/pdf' });
      }
    const modal_form                  = <ComponentLicitacionModalOferentes licitacion={props.licitacion} show={showModalInscription} showSub={showModalInscription} handleClose={handleClose}></ComponentLicitacionModalOferentes>
    const spinnerpliego               =  swSpinnerPliego?<Spinner animation="border" variant="success" className="spinner-load" size="sm" />:""
    const spinneradjudicacion         =  swSpinnerAdjudicacion?<Spinner animation="border" variant="success" className="spinner-load" size="sm" />:""
    const spinnerapertura             =  swSpinnerApertura?<Spinner animation="border" variant="success" className="spinner-load" size="sm" />:""
    return(
        <div className="prncipal-form">
            {modal_form}
            <Row className="row-principal">
                <Col md={3}><button className="form-titulo "  disabled>LICITACION Nº {' ' + props.licitacion.name}</button></Col>
                <Col md={6}></Col>
                <Col md={3}><button className="form-titulo-2 "  disabled>ESTADO: {' ' + (props.licitacion.state=== 'para_apertura'?'PARA APERTURA':props.licitacion.state=== 'adjudicada'?'ADJUDICADA':'EVALUACION')}</button></Col>
            </Row>
            <p><strong>Tipo:</strong>{'    ' + props.licitacion.type}</p>
            <p><strong>Objeto de la Licitación:</strong>{'    ' + props.licitacion.title}</p>
            <p><strong>Fecha de apertura:</strong>{'    ' + props.licitacion.fecha_hora_apertura}</p>
            <p><strong>Fecha de cierre:</strong>{'    ' + props.licitacion.fecha_hora_cierre}</p>
            <p><strong>Valor del pliego:</strong>{'    $' + props.licitacion.valor_pliego}</p>
            <p><strong>Presupuesto oficial:</strong>{'    $' + props.licitacion.presupuesto_oficial}</p>

            <Row className="row-principal">
                <Col md={4}>
                    <Button className='get-file' variant="outline-light" onClick={e =>getFileLicitacion(props.licitacion.pliego_y_decreteo_id,'pliego_y_decreto')}>
                      {download_icon}{' '}DESCARGAR PLIEGO
                      {spinnerpliego}
                    </Button> 
                </Col>
                <Col md={4}>
                    <Button className='get-file' hidden={props.licitacion.state !== 'adjudicada' && props.licitacion.state !== 'en_evaluacion'} variant="outline-light" onClick={e =>getFileLicitacion(props.licitacion.decreto_de_aprt_id,'decreto_de_apertura')}>
                      {download_icon}{' '} ACTA DE APERTURA
                      {spinnerapertura}
                    </Button> 
                </Col>
                <Col md={4}>
                    <Button className='get-file'  hidden={props.licitacion.state !== 'adjudicada'}variant="outline-light" onClick={e =>getFileLicitacion(props.licitacion.decreto_adjudicacion_id,'decreto_adjudicacion')}>
                      {download_icon}{' '}DESCARGAR DECRETO DE ADJUDICACIÓN
                      {spinneradjudicacion}
                    </Button> 
                </Col>
            </Row>
           
            <Row className="row-principal">
                <Col md={3}></Col>
                <Col md={3}></Col>
                <Col md={3}></Col>
                <Col md={3}><Button className='set-oferente' hidden={props.licitacion.state !== 'para_apertura'} onClick={e =>setshowModalInscription(true)}>{plus_book}{' '}Inscribirse</Button></Col>
            </Row>
            <button className="form-inscripto-titulo " hidden={props.licitacion.state === 'adjudicada' || !props.licitacion.show_oferentes}  disabled>INSCRIPTOS</button>
            <Table className="table-principal" hidden={props.licitacion.state === 'adjudicada' || !props.licitacion.show_oferentes} bordered hover size="sm">
              <thead>
                <tr>
                  <th>NOMBRE</th>
                  
                  <th>CUIT</th>
                </tr>
              </thead>
              <tbody>
                {trs_table}
              </tbody>

              <Form.Group as={Col} md="12" controlId="validationFormik104" hidden>
                    <Form.Label>Decreto</Form.Label>
                    <Form.Control
                      type="image"
                      placeholder="Archivo"
                      name="decreto"
                      value={decreteAdjudicacionFile}
                      onChange={e =>setDecreteAdjudicacionFile(e.currentTarget.value)}
                    />
                    <Form.Control.Feedback type="invalid" tooltip>
             
                    </Form.Control.Feedback>
              </Form.Group>
            </Table>
            
            <button className="form-inscripto-titulo " hidden={props.licitacion.state !== 'adjudicada'}  disabled>ADJUDICADOS</button>
            <Table className="table-principal" hidden={props.licitacion.state !== 'adjudicada'} bordered hover size="sm">
              <thead>
                <tr>
                  <th>NOMBRE</th>
                  
                  <th>CUIT</th>
                </tr>
              </thead>
              <tbody>
                {adj_table}
              </tbody>
            </Table>
        </div>

    )
} 

export default ComponentLicitacionForm